<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model.engineeringDrawing" :rules="validatorRules" slot="detail" :colon="false">
        <Detail ref="detailRef" v-show="showDetail" />
        <!-- <a-row :gutter="24">
          <a-col :span="24">
            <a-form-model-item label="审核意见" prop="audit">
              <a-radio-group v-model="model.audit">
                <a-radio :value="1">通过</a-radio>
                <a-radio :value="0">驳回</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="备注" prop="remark1">
              <a-textarea v-model="model.remark1" placeholder="请输入备注信息" :rows="4" />
            </a-form-model-item>
          </a-col>
        </a-row> -->

        <!-- 设计 -->
        <template v-if="ticketsData.ticketsState==2">
          <a-row :gutter="24">
            <!-- <a-col :span="12">
              <a-form-model-item label="工程预算(元)" prop="projectBudget">
                <a-input-number v-model="model.engineeringDrawing.projectBudget" placeholder="请输入工程预算" style="width: 100%" />
              </a-form-model-item>
            </a-col> -->
            <a-col :span="12">
              <a-form-model-item :label="$t('是否排水')" prop="isDrain">
                <a-radio-group v-model="model.engineeringDrawing.isDrain">
                  <a-radio :value="1">{{ $t('是') }}</a-radio>
                  <a-radio :value="0">{{ $t('否') }}</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('报装口径')" prop="caliberReport">
                <a-select v-model="model.engineeringDrawing.caliberReport" :placeholder="$t('请选择表口径')">
                  <a-select-option v-for="data in userCaliberList" :key="data.mtCaliber" :value="data.mtCaliber">
                    DN{{data.mtCaliber}}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('管线长度及规格(米)')" prop="pipelineLengthSpecifications">
                <el-input type="number" size="small" v-model.trim="model.engineeringDrawing.pipelineLengthSpecifications" :placeholder="$t('请输入管线长度及规格')" maxlength="10" show-word-limit />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item :label="$t('备注信息')" prop="remark">
                <a-textarea v-model="model.engineeringDrawing.remark" :placeholder="$t('请输入备注信息')" :rows="4" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('附件')" prop="annex">
                <JUpload v-model="fileList" accept=".pdf,.doc,.docx,.xls,.xlsx" @change="uploadChange"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </template>
        <template v-else-if="ticketsData.ticketsState==3">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('工程预算(元)')" prop="projectBudget">
                <a-input-number v-model="model.engineeringDrawing.projectBudget" :placeholder="$t('请输入工程预算')" style="width: 100%" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </template>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction,postAction } from '@/api/manage'
  import { validateDuplicateValue,historyFileUrl } from '@/utils/util'
  import JUpload from '@/components/jeecg/JUpload'
  import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import Detail from '../detail'

  export default {
    name: 'ConstructionDetailForm',
    components: {
      JUpload,
      JImageUpload,
      DetailList,
      DetailListItem,
      Detail
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        confirmLoading: false,
        showDetail: false,
        url: {
          add: "/jeecg-engineering/engineering/engineeringDrawing/add",
          edit: "/jeecg-engineering/engineering/engineeringDrawing/edit",
          queryById: "/jeecg-engineering/ticket/tickets/queryById",
          pass: "/jeecg-engineering/flowable/task/completeByDateId",
          list: "/jeecg-engineering/engineering/engineeringDrawing/list",
          upload: "sys/common/upload",
          // userList: "/jeecg-engineering/flowable/definition/userList",
          userList: "/jeecg-engineering/ticket/ticketsUser/list",
          reject: "/jeecg-engineering/flowable/task/taskRejectByDataId",
          userCaliberList:"/jeecg-charge/meter/meterCaliber/list",  //表口径请求地址
          editApproverName: "/jeecg-engineering/ticket/tickets/editApproverName",
        },
        fileList: [],
        candidateUsersList: [],
        userCaliberList: [],
        ticketsData: {},
        bool: false,
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      validatorRules() {
        return {
          audit:{ required: true,message: this.$t('请选择审批意见'), trigger: 'change' },
          remark1:{ required: true,message: this.$t('请输入备注'),trigger: 'input' },
          projectBudget: [{ required: true, message: this.$t('请输入工程预算') },],
          isDrain: [{ required: true, message: this.$t('请选择是否排水') },],
          candidateUsers:{ required: true,message: this.$t('请选择下一节点操作人'), trigger: 'change' }
        }
      },
    },
    watch:{
      'model.audit':{
        handler(val){
          if(val == 1){
            this.validatorRules.remark1.required = false;
          }else{
            this.validatorRules.remark1.required = true;
          }
        }
      }
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      queryUserCaliberList() {   //表口径请求
        let params = {}
        let that = this;
        params.pageNo = 1;
        params.pageSize = 999;
        params.column = 'mtCaliber';
        params.order = 'asc';
        getAction(this.url.userCaliberList, params).then((res) => {
          if(res.success){
            that.userCaliberList = res.result.records;
          }
        }) 
      },
      getUserList(){
        getAction(this.url.userList,{pageSize:999}).then(res=>{
          if(res.success){
            this.candidateUsersList = res.result.records;
          }
        })
      },
      uploadChange(file){
        // this.model.annex = file;
        this.$set(this.model.engineeringDrawing,'annex',file);
        this.$nextTick(()=>{
          this.$refs.form.validateField('annex');
        })
      },
      add () {
        this.edit(this.modelDefault);
      },
      edit (record,bool) {
        let that = this;
        this.bool = bool;
        // 清除表单验证
        this.$nextTick(()=>{
          this.$refs.form.clearValidate();
        })
        if(record.id){
          // 获取详情信息
          getAction(this.url.queryById,{id:record.id}).then(res=>{
            if(res.success){
              that.ticketsData = { ...res.result }
              // 报装 设计预算信息
              that.model = { 
                ...res.result.installationDetail,
                // dataId:  res.result.id,
                // installationId:  res.result.ticketsForeignId,
                // ticketsId:  res.result.id,
               }
               if (that.model.annex == null) {
                  that.fileList = []
                } else {
                  that.fileList = [that.model.annex];
                }

                 // 确保子组件已挂载
              that.$nextTick(() => {
                if(that.$refs.detailRef) {
                  that.$refs.detailRef.init(that.ticketsData, bool);
                  that.showDetail = true;
                } else {
                  console.error('子组件引用不存在');
                }
              });

            }
          })
        }
        this.getUserList();
        this.visible = true;
        this.queryUserCaliberList();
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = this.url.pass;
            let method = 'post';
            let message = this.$t('处理成功');

            let params = {
                dataId: that.ticketsData.id,
                createTicketDTO:{
                  ticketsInstallationReq: {
                    ...that.model
                  },
                },
                comment: ''
              }

            httpAction(httpurl,params,method).then((res) => {
              if (res.success) {
                that.$message.success(message);
                that.$emit('ok');
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
              that.confirmLoading = false;
            }).finally(() => {
              that.confirmLoading = false;
            })
            
          }
        })
      },
    }
  }
</script>
<style>
  .lab-title{
    font-weight: bold;
    color: #000;
  }
</style>